module.exports = __webpack_public_path__ + "img/userCenter.24fdd21.png";